"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxEdge = void 0;
var utils_1 = require("../../../utils");
var bbox_1 = require("./bbox");
exports.IBboxEdge = (0, utils_1.IRecord)({
    type: 'edge',
    location: 'n',
    centerPos: (0, utils_1.IPos)(),
    halfLength: 0,
    parent: (0, bbox_1.IBbox)()
});
